export const defaultModules = {
  toolbar: [
    ['bold', 'italic', 'underline', 'strike'], // toggled buttons
    // ['blockquote', 'code-block'],

    // [{ header: 1 }, { header: 2 }], // custom button values
    [{ list: 'ordered' }, { list: 'bullet' }],
    [{ align: [''] }],
    // [{ script: 'sub' }, { script: 'super' }], // superscript/subscript
    // [{ indent: '-1' }, { indent: '+1' }], // outdent/indent
    // [{ direction: 'rtl' }], // text direction
    [
      {
        size: ['8px', '10px', '12px', false, '16px', '18px', '20px', '22px', '24px', '36px'],
      },
    ], // custom dropdown
    // [{ size: ['small', false, 'large', 'huge'] }],
    // [{ header: [1, 2, 3, 4, 5, 6, false] }],
    [
      { color: [] },
      { background: [] }
    ], // dropdown with defaults from theme
    [{
      font: ['Arial', 'Arial Black', 'Arial Narrow', 'Bookman', 'Calibri', 'Calibri Light', 'Century Gothic', 'Comic Sans MS', 'Courier New', 'Garamond', 'Georgia', 'Helvetica', 'Impact', 'Lucida Console', 'Monospace', 'Palatino Linotype', 'Sans-serif', 'Serif', 'Tahoma', 'Trebuchet MS', 'Times New Roman', 'Verdana']
    }],
    // ['clean'], // remove formatting button

    ['link']
    //, 'image', 'video'], // link and image, video

  ],
};